import { load } from '@shopify/theme-sections';
import '../sections/product';
import '../sections/product-details';

load('product');
load('product-details');
